<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Top Traffic Sources
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/reporting?activeTab=traffic"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove()"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <div
      v-if="!loading && Object.keys(traffic_sources).length > 0"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td>
              <span>Source</span>
            </td>
            <td>
              <span>Visits</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(visits, source) in traffic_sources"
            :key="source"
          >
            <td class="keyword">
              <span :class="getTrafficIcon(source).span"><i :class="getTrafficIcon(source).icon" /></span> {{ source }}
            </td>
            <td>
              {{ visits > 0 ? visits.toLocaleString() : 0 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="Object.keys(traffic_sources).length === 0 && !error"
      class="loading_widget_data"
    >
      <div v-if="loading">
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>
      <div v-else>
        No Data
      </div>
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      traffic_sources: {},
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'trafficData',
      'preview',
      'trafficDataError',
    ]),
    ...mapState('user', ['user']),
  },
  watch: {
    trafficData: {
      handler() {
        this.setData();
      },
      deep: true
    },
    trafficDataError: {
      handler() {
        if (this.trafficDataError) {
          this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>There's a problem with your account connection. </span>`;
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (this.trafficData?.tables?.traffic_sources?.data) {
      this.setData();
    }
  },
  methods: {
    setData() {
      if (this.activeWebsite.has_ga_connection) {
        this.traffic_sources = this.trafficData.tables.traffic_sources.data.data ?? {};
        this.loading = false;
      } else {
        this.error = `
                    <i class="fa fa-btn fa-exclamation-triangle"></i>
                    <span>There's a problem with your account connection. </span>
                    <a href="/website/settings/${this.activeWebsite.hash_id}">Go to settings</a>
                `;
        this.loading = false;
      }
    },
    getTrafficIcon(source) {
      source = source.trim();

      switch (source) {
        case 'Organic Search':
          return {
            span: 'text-success',
            icon: 'fad fa-search xs-mr-5"></'
          }
        case 'Paid Search':
          return {
            span: 'text-primary',
            icon: 'fad fa-ad xs-mr-5"></'
          }
        case 'Referral':
          return {
            span: 'text-warning',
            icon: 'fad fa-external-link xs-mr-5'
          }
        case 'Direct':
          return {
            span: 'text-danger',
            icon: 'fad fa-bullseye xs-mr-5'
          }
        case 'Display':
          return {
            span: 'text-gmb',
            icon: 'fad fa-ad xs-mr-5'
          }
        case 'Social':
          return {
            span: 'text-info',
            icon: 'fab fa-twitter xs-mr-5'
          }
        case 'Email':
          return {
            span: 'text-primary',
            icon: 'fas fa-envelope xs-mr-5'
          }
        case '(Other)':
          return {
            span: 'text-dark',
            icon: 'fad fa-globe-europe xs-mr-5'
          }
        default:
          return source;
      }
    }
  },
}
</script>

<style scoped>
td {
  width: 50%;
}

tr td:not(:first-of-type) {
  text-align: center;
}
</style>
